import { AspectRatio, Box, SimpleGrid, Text } from "@chakra-ui/react";
import { useLocalizedData, useTranslations } from "contexts/LocalizationContext/hooks";
import { DISTANCE_BG, distanceRanges } from "../config";
import type { DistanceMarkProps } from "../types";

const DistanceMark = ({ compensation, translationKey, ...props }: DistanceMarkProps) => {
  const { getLocalizedCurrency } = useLocalizedData();
  const translations = useTranslations();
  return (
    <Box mx="auto" my={2} textAlign="center" {...props}>
      <Text color="danger.600" fontWeight="medium" fontSize="md" lineHeight="150%">
        {getLocalizedCurrency(Number(compensation), "EUR")}
      </Text>
      <Text fontSize="xs" lineHeight="150%">
        {translations(translationKey)}
      </Text>
    </Box>
  );
};

export const Info = () => (
  <AspectRatio ratio={17 / 11} maxW="500px" mx="auto">
    <SimpleGrid
      paddingInlineStart={5}
      paddingInlineEnd={5}
      gap={2}
      justifyContent="space-evenly"
      columns={3}
      bgImage={DISTANCE_BG}
      bgRepeat="no-repeat"
      bgSize="cover"
    >
      {distanceRanges.map(({ translationKey, compensation, marginBottom }) => (
        <DistanceMark
          key={translationKey}
          compensation={compensation}
          translationKey={translationKey}
          marginBottom={marginBottom}
        />
      ))}
    </SimpleGrid>
  </AspectRatio>
);
